import TrainIcon from './../../../../assets/images/train_naganyan.png';

import { Box, Grid, GridItem } from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';
import { commonStyle } from '../../../../common/styles';
import { getTrainColor } from '../../../../common/tranists';
import {
  DialogTrainInfoType,
  DialogTrainsInfoType
} from '../../../../context/TransitsContextProvider';

type Props = {
  placeInfo: DialogTrainsInfoType;
  trainInfo: DialogTrainInfoType;
};

export const Schedule: React.FC<Props> = (props) => {
  const { trainInfo: train } = props;
  const currenttRef = useRef<HTMLDivElement>(null); //車両が現在いる電停

  // リストの初期スクロール位置を車両の現在地へ
  useEffect(() => {
    if (currenttRef?.current?.scrollIntoView) {
      currenttRef.current.scrollIntoView(true);
    }
  }, [train]);

  return (
    <Box
      gridArea='schedule'
      w='100%'
      h='100%'
      padding='5px 15px 3px 5px'
      overflowY='auto'
    >
      {train.schedules.map((schedule, index) => {
        const isBetween =
          train.station_name_former !== train.station_name_latter;
        const currentStation = schedule.no === train.self_station_no;

        const firstStation = index === 0;
        const lastStation = index + 1 === train.schedules.length;

        return (
          <React.Fragment key={`schedule_${index}`}>
            <Grid
              w='100%'
              h={lastStation ? '70px' : '100px'}
              gridTemplateAreas={`'line ... name ... time' 'line ... arrow ... ...'`}
              gridTemplateColumns='33px 7px 1fr 3px 45px'
              gridTemplateRows={lastStation ? '60px 10px' : '60px 40px'}
              fontWeight='bold'
            >
              {/* 車線＋車両アイコン画像 */}
              <GridItem
                gridArea='line'
                sx={{
                  ...commonStyle.center,
                  alignItems: firstStation ? 'flex-end' : 'flex-start'
                }}
                ref={currentStation ? currenttRef : undefined}
              >
                {/* 車線 */}
                <Box
                  w='10px'
                  h={lastStation ? '45%' : '100%'}
                  bgColor={getTrainColor(train.course)}
                  zIndex={-2} //上書き用の白色より下
                >
                  {/* 円 */}
                  <Box
                    position='relative'
                    w='20px'
                    h='20px'
                    left='-5px'
                    top='22px'
                    bgColor='white'
                    border={`solid ${getTrainColor(train.course)} 4px`}
                    borderRadius='50%'
                    sx={{ ...commonStyle.center }}
                  ></Box>
                  {/* アイコン画像 */}
                  {currentStation && (
                    <Box
                      position='relative'
                      w='36px'
                      h='36px'
                      left='-13px'
                      top={isBetween ? '40px' : '-6px'}
                      sx={{ ...commonStyle.center }}
                    >
                      <img
                        width='100%'
                        height='100%'
                        src={TrainIcon}
                        alt='image'
                      ></img>
                    </Box>
                  )}

                  {/* 始点のラインの上部を白色で上書き */}
                  {firstStation && (
                    <Box
                      position='relative'
                      w='20px'
                      h='24px'
                      top={currentStation ? '-56px' : '-20px'}
                      left='-5px'
                      bgColor='white'
                      zIndex={-1} //車線より上、円より下
                    ></Box>
                  )}
                </Box>
              </GridItem>

              {/* 駅名＋駅番号 */}
              <GridItem
                gridArea='name'
                bgColor='lightgrey'
                border={
                  currentStation && !isBetween ? 'solid red 3px' : undefined
                }
                borderRadius='5px'
                sx={{ ...commonStyle.center }}
              >
                <Grid
                  w='100%'
                  h='100%'
                  gridTemplateAreas={`'no ... ename' 'no ... name'`}
                  gridTemplateRows='45% 55%'
                  gridTemplateColumns={
                    currentStation && !isBetween
                      ? '37px 0px 1fr'
                      : '40px 0px 1fr'
                  }
                >
                  <GridItem
                    gridArea='no'
                    sx={{ ...commonStyle.center, justifyContent: 'flex-end' }}
                  >
                    <Box
                      w='32px'
                      h='32px'
                      color='white'
                      bgColor='black'
                      borderRadius='5px'
                      fontWeight={undefined}
                      fontSize={schedule.no.length >= 3 ? '12px' : '16px'}
                      sx={{ ...commonStyle.center }}
                    >
                      {schedule.no}
                    </Box>
                  </GridItem>

                  <GridItem
                    gridArea='ename'
                    fontSize='clamp(0.688rem, -0.767rem + 7.27vw, 0.938rem)'
                    sx={{ ...commonStyle.center, alignItems: 'flex-end' }}
                  >
                    {schedule.en}
                  </GridItem>

                  <GridItem
                    gridArea='name'
                    fontSize={
                      // 電停名称変更に対応（スタジアムシティ）
                      schedule.ja.length > 10
                        ? 'clamp(0.688rem, -0.767rem + 7.27vw, 0.938rem)'
                        : 'clamp(0.875rem, -1.307rem + 10.91vw, 1.25rem)'
                    }
                    sx={{ ...commonStyle.center, alignItems: 'flex-start' }}
                  >
                    {schedule.ja}
                  </GridItem>
                </Grid>
              </GridItem>

              {/* 矢印 */}
              <GridItem gridArea='arrow' sx={{ ...commonStyle.center }}>
                {!lastStation && (
                  <Box
                    w='0'
                    h='0'
                    border='solid 15px transparent'
                    borderTop={`solid 10px ${
                      currentStation && isBetween ? 'red' : 'lightgrey'
                    }`}
                    marginTop='15px'
                  ></Box>
                )}
              </GridItem>

              {/* 到着時刻 */}
              <GridItem
                gridArea='time'
                borderTop='solid lightgrey 2px'
                borderBottom='solid lightgrey 2px'
                fontSize='14px'
                sx={{ ...commonStyle.center }}
              >
                {schedule.time === null ? '' : `${schedule.time}`}
              </GridItem>
            </Grid>
          </React.Fragment>
        );
      })}
    </Box>
  );
};
